module.exports = __webpack_public_path__ + "static/img/2.ce6ba76.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/2.png
// module id = v8AW
// module chunks = 0